import { render, staticRenderFns } from "./RememberDetail.vue?vue&type=template&id=212373dc&scoped=true&"
import script from "./RememberDetail.vue?vue&type=script&lang=js&"
export * from "./RememberDetail.vue?vue&type=script&lang=js&"
import style0 from "./RememberDetail.vue?vue&type=style&index=0&id=212373dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212373dc",
  null
  
)

export default component.exports